type AvatarParticipant = {
  identity?: string
  name?: string
}

export function isAvatarRendererParticipant(
  participant: AvatarParticipant | null | undefined,
): boolean {
  if (!participant) return false

  const identity = participant.identity || ''

  return (
    participant.name === 'Fedor Avatar' ||
    identity.startsWith('avatar-') ||
    identity.startsWith('fedor-') ||
    identity.startsWith('fedor-page-')
  )
}

export function shouldShowFedorParticipant(
  isAvatarRenderer: boolean,
  hasAvatarRenderer: boolean,
): boolean {
  return isAvatarRenderer || !hasAvatarRenderer
}
